import { useTheme } from "@emotion/react";
import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CenteredText from "components/CenteredText";
import Page from "components/Page";

import PepperChat from "assets/images/pepper_chat.svg"

const Scansiona = ({ ms = 5 }) => {
  const theme = useTheme();


  return (
    <Page bg={theme.palette.background.paper}>
      <Stack spacing={2} sx={{
        display: 'flex',
        flex: 1
      }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          <CenteredText>
            <img src={PepperChat} alt={"pepper chat umano"} />
          </CenteredText>
          <CenteredText>
            <Typography variant="h5" sx={{ paddingInline: '2rem', color: theme.palette.white.main }}>
              Scansiona nuovamente il codice QR sulla vetrina per iniziare l'esperienza.
            </Typography>
          </CenteredText>
        </Box>
      </Stack>
    </Page>
  )
}

export default Scansiona;